import React from "react";
import dayjs from "dayjs";
import { CheckOutlined } from "@ant-design/icons";
import Cli from "../../styles/jjj.png";
import { TEST_ROWS } from "../../pages/labTests";
import "./LabPreview.css";

function Box({ checked, label }) {
  return (
    <div className="lab-sheet-test">
      <span className={`lab-sheet-box ${checked ? "is-checked" : ""}`}>{checked ? <CheckOutlined /> : null}</span>
      <span className="lab-sheet-label">{label}</span>
    </div>
  );
}

function LabPreview({ patientName, date, age, discount, checks }) {
  return (
    <div className="lab-sheet" dir="rtl">
      <div className="lab-sheet-header">
        <img src={Cli} alt="" />
        <div className="lab-sheet-banner">
          <p>پاکێجی پشکنینی تایبەت بە ئەنجامدانی</p>
          <p>
            <strong>{discount || 0} %</strong> نەشتەرگەری جوانکاری لوت بە داشکاندنی :
          </p>
        </div>
      </div>

      <div className="lab-sheet-meta">
        <p>
          <span>ناو :</span> {patientName || "—"}
        </p>
        <div className="lab-sheet-meta-row">
          <p>
            <span>بەروار :</span> {date ? dayjs(date).format("YYYY-MM-DD") : "—"}
          </p>
          <p>
            <span>تەمەن :</span> {age ? `${age} ساڵ` : "—"}
          </p>
        </div>
      </div>

      <div className="lab-sheet-tests">
        {TEST_ROWS.map((row) => (
          <div key={row.id} className="lab-sheet-test-row">
            <Box checked={!!checks[row.left.form]} label={row.left.label} />
            <Box checked={!!checks[row.right.form]} label={row.right.label} />
          </div>
        ))}
      </div>

      <div className="lab-sheet-sign">
        <i />
        <span>Doctor's signature</span>
      </div>

      <div className="lab-sheet-footer">سلێمانی-شەقامی توویمەلیک-سەروو فولکەی کاوە · السلیمانیة - شارع توی ملیک - قرب فلکة کاوة</div>
    </div>
  );
}

export default React.memo(LabPreview);
